import { useSelector } from "react-redux";

function useUsuario() {
  return useSelector(state => state.usuario);
}

export default useUsuario;
